import { Table, Empty } from "antd";
import { getRecipeColumns } from "./recipes.columns";

export default function RecipesTable({
  recipes = [],
  loading = false,
  total = 0,
  page = 1,
  pageSize = 10,
  onPageChange,
  onToggleDisable,
  onToggleTrending,
  onEdit,
  onDelete,
}) {
  const columns = getRecipeColumns(
    onToggleDisable,
    onToggleTrending,
    onEdit,
    onDelete
  );

  return (
    <Table
      className="recipes-table"
      columns={columns}
      dataSource={recipes}
      rowKey="_id"
      loading={loading}
      locale={{ emptyText: <Empty description="No recipes found" /> }}
      pagination={{
        current: page,
        pageSize,
        total,
        showSizeChanger: false,
        onChange: (p) => onPageChange?.(p),
      }}
    />
  );
}